<template>
    <div>
        <v-card>
            <v-card-title class="blue-grey white--text" style="height: 50px;">
                <span class="mt-n2">INTEGRACIÓN</span>
            </v-card-title>
            <v-card-text>
                <v-form>
                    <v-container>
                        <v-row>
                          <v-col cols="12" md="6" class="mt-5">
                            <v-row>
                              <v-col cols="12" md="3">
                                  <v-text-field v-model="numero" label="Solicitud" outlined dense disabled filled></v-text-field>
                              </v-col>
                              <v-col cols="8" md="7">
                                  <v-text-field v-model="proveedor" label="Proveedor" outlined dense disabled filled></v-text-field>
                                  <h4 class="ml-2 mt-n7">{{ rut }}</h4>
                              </v-col>
                              <v-col cols="4" md="2">
                                  <v-btn class="mt-2" @click="solicita=true" small color="indigo" dark rounded>
                                      <v-icon small>find_replace</v-icon>
                                  </v-btn>
                              </v-col>
                            </v-row>
                          </v-col>
                          <v-col cols="12" md="6" class="mt-5">
                            <v-row>
                              <v-col cols="12" md="3">
                                  <v-text-field v-model="moneda" label="Moneda" outlined dense maxlength="3"></v-text-field>
                              </v-col>
                              <v-col cols="12" md="4">
                                  <v-menu v-model="menu1" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                                      <template v-slot:activator="{ on, attrs }">
                                          <v-text-field v-model="date1" label="Fec. Paridad" prepend-icon="event" readonly v-bind="attrs" v-on="on" dense outlined></v-text-field>
                                      </template>
                                      <v-date-picker v-model="date1" @input="menu1 = false"></v-date-picker>
                                  </v-menu>
                              </v-col>
                              <v-col cols="12" md="3">
                                  <v-text-field @keypress="onlyDecimal" v-model="cambio" label="Paridad" outlined dense></v-text-field>
                              </v-col>
                            <v-col cols="4" md="2">
                                  <v-btn @click="calcular_cambio()" class="mt-2" small color="indigo" dark rounded>
                                      <v-icon small>flash_on</v-icon>
                                  </v-btn>
                              </v-col>
                            </v-row>
                          </v-col>
                          <v-col cols="12" md="12">
                              <v-row>
                                  <v-col cols="12" md="12" class="mt-n5">
                                      <v-data-table dense dark fixed-header height="230" 
                                          :headers="detalle_head" 
                                          :items="detalle_items" 
                                          :page.sync="page" 
                                          :items-per-page="itemsPerPage" 
                                          hide-default-footer 
                                          class="elevation-1 text-size" 
                                          @page-count="pageCount = $event">
                                          <template v-slot:item.precio="{ item }">
                                                <span>{{ new Intl.NumberFormat("de-DE").format(parseFloat(item.precio)) }}</span>
                                          </template>
                                          <template v-slot:item.paridad="{ item }">
                                                <span>{{ new Intl.NumberFormat("de-DE").format(parseFloat(item.paridad)) }}</span>
                                          </template>
                                          <template v-slot:item.total="{ item }">
                                                <span> $ {{ new Intl.NumberFormat("de-DE").format(parseFloat(item.total)) }}</span>
                                          </template>
                                          <template v-slot:item.clp="{ item }">
                                                <span>$ {{ new Intl.NumberFormat("de-DE").format(parseFloat(item.clp)) }}</span>
                                          </template>
                                          <template v-slot:item.costo="{ item }" >
                                              <div @click="open_valoriza(item)" style="background-color:gold;">
                                                <span class="black--text">&nbsp;&nbsp;$ {{ new Intl.NumberFormat("de-DE").format(parseFloat(item.costo)) }}&nbsp;&nbsp;</span>
                                                <div style="float:right"><v-icon x-small color="black">edit</v-icon></div>
                                              </div>
                                          </template>
                                      </v-data-table>
                                  </v-col>
                              </v-row>                                
                            </v-col>
                        </v-row>
                    </v-container>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-row class="mt-n7">
                    <v-col cols="12" md="7" class="text-end"></v-col>
                    <v-col cols="12" md="2" class="mt-2">
                        <v-btn @click="clsInput()" class="ml-2" small color="teal" dark rounded block><v-icon small>add_circle</v-icon><span class='text-btn'>Nuevo</span></v-btn>
                    </v-col>
                    <v-col cols="12" md="2" class="mt-2">
                        <v-btn @click="open_compra()" class="ml-2" small color="teal" dark rounded block><v-icon small>save</v-icon><span class='text-btn'>Integrar</span></v-btn>
                    </v-col>
                    <v-col cols="12" md="1"></v-col>
                    <v-col cols="12" md="12" class="mt-n10">&nbsp;</v-col>
                </v-row>
            </v-card-actions>
        </v-card>

        <!-- dialog Solicitudes --> 
        <v-dialog v-model="solicita" transition="dialog-bottom-transition" max-width="60%" persistent>
            <v-card>
                <v-card-title>
                    <v-row>
                        <v-col cols="6" md="3">
                            <v-btn @click="solicita=false" color="red" small dark><v-icon small>close</v-icon></v-btn>
                        </v-col>
                        <v-col cols="6" md="5">
                            <!-- <h6 v-if="press_btn=='update'">{{proveedor}}</h6>                 -->
                        </v-col>
                        <v-col cols="12" md="4" class="text-right">
                            <v-text-field class='ml-5 mr-2 text-caption' v-model="solicitasearch" label="Buscar Solicitud" dense required></v-text-field>
                        </v-col>
                    </v-row>
                </v-card-title>
                <v-card-text>
                    <v-data-table @click:row="handleSolicita" dense dark :search="solicitasearch" :headers="solicitatitulo" 
                        :items="solicitalista" :page.sync="solicitapage" :items-per-page="solicitaitemsPerPage"  
                        @page-count="solicitapageCount = $event" hide-default-footer class="elevation-1 text-size" fixed-header height="300">
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-dialog>
        <!-- dialogo Valoriza -->
        <v-dialog v-model="d_valoriza" transition="dialog-bottom-transition" max-width="35%" persistent>
            <v-card>
            <v-card-text>
                <v-row class="mt-5">
                    <v-col cols="12" md="12" class="text-center">
                        <v-alert class='text-caption' dense text type="success">
                            <h5>SKU: <span class="black--text">{{ sku }}</span></h5>
                            <h5>PRODUCTO: <span class="black--text">{{ nombre }}</span></h5>
                        </v-alert>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" md="3"></v-col>
                    <v-col cols="12" md="4">
                        <v-text-field @keypress="onlyNumber" v-model="costo_integra" label="Costo Integra" outlined dense></v-text-field>
                    </v-col>
                    <v-col cols="12" md="1">
                        <v-btn @click="add_valoriza()" small fab dark color="indigo"><v-icon>playlist_add</v-icon></v-btn>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-divider class="mt-2 mb-2"></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="d_valoriza=false" color="indigo">Close</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- dialogo Compra -->
        <v-dialog v-model="d_compra" transition="dialog-bottom-transition" max-width="50%" persistent>
            <v-card>
            <v-card-text>
                <v-row class="mt-5">
                    <v-col cols="12" md="12" class="text-center">
                        <v-alert class='text-caption' dense text type="success">
                            <h5>SOLICITUD: <span class="black--text">{{ numero }}</span></h5>
                            <h5>CLIENTE: <span class="black--text">{{ proveedor }}</span></h5>
                        </v-alert>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" md="4">
                        <v-text-field class='text-caption' @keypress="onlyNumber" v-model="orden" label="N° Compra" outlined dense required></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-menu v-model="menu10" :close-on-content-click="false" :nudge-left="20" transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field class="text-caption" v-model="emision" label="Fec. Emision" readonly v-bind="attrs" v-on="on" dense outlined></v-text-field>
                            </template>
                            <v-date-picker v-model="emision" @input="menu10 = false"></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-menu v-model="menu30" :close-on-content-click="false" :nudge-left="20" transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field class="text-caption" v-model="vence_pago" label="Fec. Vencimiento" readonly v-bind="attrs" v-on="on" dense outlined></v-text-field>
                            </template>
                            <v-date-picker v-model="vence_pago" @input="menu30 = false"></v-date-picker>
                        </v-menu>
                    </v-col>
                </v-row>
                <v-row class="mt-n10"> 
                    <v-col cols="12" md="4">
                        <v-select class='text-caption' v-model="forma_pago" :items="array_pago" label="Forma Pago" dense outlined></v-select>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-text-field class='text-caption' v-model="ref_pago" label="Referencia" outlined dense required></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-select v-model="bodega" :items="bodegas" item-value="id" item-text='name' label="Bodega" dense outlined></v-select>
                        <!-- <v-text-field class='text-caption' v-model="observa" label="Observacion" outlined dense required disabled filled></v-text-field> -->
                    </v-col>
                </v-row>
            </v-card-text>
            <v-divider class="mt-2 mb-2"></v-divider>
            <v-card-actions>
                <v-btn text @click="d_compra=false" color="indigo">Close</v-btn>
              <v-spacer></v-spacer>
              <v-btn v-if="btn_grabar==true" @click="saveCompra()" rounded small dark width="100" color="teal">Grabar</v-btn>
              <v-btn v-else rounded small dark width="100" color="grey">Grabar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <snack :Msg="Msg" :color="color" :msgbox="msgbox"/>
        <dialogo :loading="loading"/>
    </div>
</template>
<style scoped>
.text-size >>> td {
    font-size: 9pt !important;
    height: 33px !important;
    /*background-color: lightyellow;*/ 
}
.col-color >>> th {
    background-color: lightgrey;
}
.form-space {
    margin-top:-20px;
}
</style>
<script>
import axios from 'axios';
import snack from '@/components/snack.vue';
import dialogo from '@/components/dialogo.vue';
export default {
    name:'Importa', 
    components:{dialogo, snack},
    props: ['usu','contrato'],   
    data(){
        return{
            //contrato:'123',
            loading:false,
            msgbox:false,
            color:'',
            Msg:'',
            rut:'',
            proveedor:'',
            entidad:0,
            moneda:'',
            cambio:0,
            bodega:0,
            bodegas:[],
            costo_integra:0,
            sku:'',
            nombre:'',
            numero:0,
            menu1:false,
            date1: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10),
            fecha: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10),
            idItems:0,
            //detalle solicitud
            page: 1,
            pageCount: 0,
            itemsPerPage: 1000000,
            detalle_head:[
                { text: 'Sku', align: 'start', sortable: true, value: 'sku' },
                { text: 'Producto', align: 'start', sortable: true, value: 'producto' },
                //{ text: 'Cod. Universal', align: 'center', sortable: true, value: 'universal' },
                { text: 'Cantidad', align: 'center', sortable: true, value: 'cantidad' },
                { text: 'Cod.Proveedor', align: 'center', sortable: true, value: 'codigo' },
                { text: 'Precio', align: 'end', sortable: true, value: 'precio' },
                { text: 'Moneda', align: 'center', sortable: true, value: 'moneda' },
                { text: 'Paridad', align: 'end', sortable: true, value: 'paridad' },
                { text: 'Total', align: 'end', sortable: true, value: 'total' },
                { text: 'Unitario', align: 'end', sortable: true, value: 'clp' },
                { text: 'Costo Integra', align: 'end', sortable: false, value: 'costo' },
            ],
            detalle_items:[],
            //lista solicitudes
            solicita:false,
            solicitasearch:'',
            solicitatitulo:[
                { text: 'Fecha', align: 'start', sortable: true, value: 'fecha', width:'' },
                { text: 'Numero', align: 'start', sortable: true, value: 'numero' },
                { text: 'Rut', align: 'start', sortable: true, value: 'rut' },
                { text: 'Proveedor', align: 'start', sortable: true, value: 'proveedor' },
            ],
            array_solicitud:[],
            solicitalista:[],
            solicitapage: 1,
            solicitapageCount: 0,
            solicitaitemsPerPage: 1000000,
            btn_grabar:true,
            d_valoriza:false,
            id_lista:0,

            d_compra:false,
            orden:'',
            menu10:false,
            emision:(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10),
            menu30:false,
            vence_pago:(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10),
            array_pago:['Efectivo','Tarjeta','Transferencia','Cheque','Credito'],
            forma_pago:'',
            ref_pago:'',
            observa:'Importacion',
            impuesto:19
        }
    },
    async mounted(){
        this.loading=true;
        await this.search_bodegas();
        await this.search_importa();
        this.loading=false;
    },
    methods:{
        async search_bodegas(){
          try {
            const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/bodegas/'+this.contrato);
            const datos=response.data;
            if (datos[0].existe=='si'){
                datos.forEach(element => {
                  this.bodegas.push({
                    id: element.ID,
                    name: element.Nombre
                  })
                });
            }                
          } catch (error) {
              console.log(error)
          };
        },
        async search_importa(){
          this.array_solicitud=[];
          this.solicitalista=[];
          try {
            const rut_importa = 'all';
            const estado_importa = 'V';
            const par_importa = this.contrato + '/' + rut_importa + '/' + estado_importa; 
            const res_importa = await axios.get(process.env.VUE_APP_URL + '/api/inv/importa/' + par_importa);
            const data_importa=res_importa.data;
            if (data_importa[0].existe=='si'){
                this.array_solicitud = data_importa;
                let myNumber = 0;
                let myRut = '';
                this.array_solicitud.forEach(element => {
                    if(parseFloat(myNumber)!=parseFloat(element.Numero) && myRut!=element.Pro_Rut){
                        this.solicitalista.push({
                            'fecha': element.Fecha,
                            'numero': element.Numero,
                            'rut': element.Pro_Rut,
                            'proveedor': element.Proveedor
                        })
                    }
                    myNumber = element.Numero;
                    myRut = element.Pro_Rut;
                });
            }
          } catch (error) {
              console.log(error)
          }
        },
        async handleSolicita(fila) {
            this.detalle_items=[];
            const filter = this.array_solicitud.filter(res => parseFloat(res.Numero) == parseFloat(fila.numero) && res.Pro_Rut == fila.rut);
            if(filter.length!=0){
                filter.forEach(element => {
                    this.detalle_items.push({
                        'id': element.ID,
                        'sku': element.Sku,
                        //'universal': element.Universal,
                        'producto': element.Producto,
                        'cantidad': element.Cantidad,
                        'codigo': element.Pro_Codigo,
                        'precio': element.Precio,
                        'moneda': element.Moneda,
                        'paridad': element.Valor_Cambio,
                        'total': element.Total_CLP, 
                        'clp': element.Valor_CLP,
                        'costo': element.Costo_CLP,
                    });
                });
                this.numero = filter[0].Numero;
                this.entidad = filter[0].Entidad;
                this.rut = filter[0].Pro_Rut;
                this.proveedor = filter[0].Proveedor;
                this.moneda = filter[0].Moneda;
                this.cambio = filter[0].Valor_Cambio;
                this.bodega = parseInt(filter[0].Bodega);
                if(filter[0].Fecha_Cambio!=null){
                  this.date1 = filter[0].Fecha_Cambio;
                } else {
                  this.date1 = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10);
                }
            }
            this.solicita=false;
        },
        async calcular_cambio(){
          if(this.moneda!=null && this.cambio!=null){
            if(this.moneda.trim()!=''){
              if(this.detalle_items.length!=0){
                this.detalle_items.forEach(element => {
                  const myCantidad = element.cantidad;
                  const myPrecio = element.precio;
                  element.moneda = this.moneda;
                  element.paridad = this.cambio;
                  element.total = parseFloat((parseFloat(myPrecio)*parseFloat(this.cambio)) * parseFloat(myCantidad)).toFixed(2);
                  if(parseFloat(this.cambio)!=0){
                    element.clp = parseFloat(parseFloat(myPrecio)*parseFloat(this.cambio)).toFixed(2);
                    element.costo = parseFloat(parseFloat(myPrecio)*parseFloat(this.cambio)).toFixed(2);
                  } else {
                    element.clp = parseFloat(myPrecio);
                    element.costo = parseFloat(myPrecio);
                  }
                });
              } else {
                this.Msg='No existen datos en la lista para calcular'
                this.color='red';
                this.msgbox=true;
                this.showSnack();
              }
            } else {
              this.Msg='ingrese moneda y paridad'
              this.color='red';
              this.msgbox=true;
              this.showSnack();
            }
          } else {
            this.Msg='ingrese moneda y paridad'
            this.color='red';
            this.msgbox=true;
            this.showSnack();
          }
        },
        open_valoriza(line){
          this.id_lista=line.id;
          this.sku = line.sku;
          this.nombre = line.producto;
          this.costo_integra = line.costo;
          this.d_valoriza = true;
        },
        async add_valoriza(){
            const found =  this.detalle_items.filter(res => res.sku == this.sku && res.id == this.id_lista);
            if(found.length!=0){
                found[0].costo = this.costo_integra;
            };
            this.d_valoriza=false;
        },
        clsInput(){
            this.detalle_items=[];
            this.numero=0;
            //this.btn_grabar=true;
            this.date1=(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10);
            this.fecha=(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10);
            this.entidad=0;
            this.proveedor='';
            this.rut='';
            this.moneda='';
            this.paridad='';
            this.bodega=0;
            this.sku='';
            this.nombre='';
            this.costo_integra=0;
            this.id_lista=0;
        }, 
        onlyNumber ($event) {
            let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
            if ((keyCode < 48 || keyCode > 57)) { // && keyCode !== 46 is dot
                $event.preventDefault();
            }
        },
        onlyDecimal ($event) {
            let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
            if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // && keyCode !== 46 is dot
                $event.preventDefault();
            }
        },
        showSnack(){
            setTimeout(()=>{this.msgbox=false},3000)
        },
        async saveCompra(){
            this.loading=true;
            if(this.orden!=''){
                if(this.forma_pago!=''){
                    if(this.bodega!=0){
                        if(this.detalle_items[0].moneda!=null){
                            const myMoneda = '' + this.detalle_items[0].moneda;
                            if(myMoneda.trim()!=''){
                                try {
                                    //validar si el numero vs proveedor existe
                                    const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/orden/entidad/C/'+this.contrato+'/'+this.orden+'/'+this.proveedor);
                                    const datos=response.data;
                                    if (datos[0].existe=='si'){
                                        this.Msg='Numero de Compra ya existe para el proveedor seleccionado'
                                        this.color='success';
                                        this.msgbox=true;
                                        this.showSnack();
                                    } else{
                                        //grabar la compra de importacion
                                        const totalLines = this.detalle_items.length;
                                        let totalSave = 0;
                                        for (let index = 0; index < this.detalle_items.length; index++) {
                                            const element = this.detalle_items[index];
                                            // obtenemos el precio con iva
                                            const newIva=(parseFloat(element.costo)*parseFloat(this.impuesto))/100;
                                            const newPrecio=Math.round(parseFloat(element.costo)+newIva);
                                            var parametros={
                                                'contrato': this.contrato,
                                                'orden': this.orden,
                                                'entidad': this.entidad,
                                                'tipo': 'Neto',
                                                'cv': 'C',
                                                'sku': element.sku,
                                                'oems': '',
                                                'producto': element.producto,
                                                'neto': element.costo,
                                                'precio': newPrecio,
                                                'cantidad': element.cantidad,
                                                'bodega':  this.bodega,
                                                'observa': this.observa,
                                                'usuario': this.usu,
                                                'referencia':'0',
                                                'emision': this.emision,
                                                'exenta': 'NO',
                                                'for_pago': this.forma_pago,
                                                'ref_pago': this.ref_pago,
                                                'fec_pago': this.vence_pago
                                            };
                                            const response = await axios.post(process.env.VUE_APP_URL + '/api/inv/compraventa/nueva/v4',parametros);
                                            const datos=response.data;
                                            if (datos=='si'){ 
                                                totalSave = parseInt(totalSave) + 1
                                            }
                                        };
                                        if(parseInt(totalSave)!=0){
                                            const totalImporta = await this.update_importa();
                                            if(parseInt(totalSave) == parseInt(totalLines)){
                                                if(parseInt(totalSave) == parseInt(totalImporta)){
                                                    this.Msg='La integracion se ha ingresado con exito'
                                                    this.color='success';
                                                    this.msgbox=true;
                                                    this.showSnack();
                                                } else {
                                                    this.Msg='Diferencia entre productos Integrados vs Compra, favor revisar'
                                                    this.color='warning';
                                                    this.msgbox=true;
                                                    this.showSnack();
                                                }
                                            } else {
                                                if(parseInt(totalSave) != parseInt(totalImporta)){
                                                    this.Msg='Algunos productos no fueron ingresados a la Compra, favor revisar'
                                                    this.color='warning';
                                                    this.msgbox=true;
                                                    this.showSnack();
                                                } else {
                                                    this.Msg='Algunos productos no fueron integrados, favor revisar'
                                                    this.color='warning';
                                                    this.msgbox=true;
                                                    this.showSnack();
                                                }
                                            }
                                        };
                                        this.btn_grabar=false
                                    }
                                } catch (error) {
                                    console.log(error)
                                    this.Msg='Allgo anda mal, favor informar a soporte'
                                    this.color='error';
                                    this.msgbox=true;
                                    this.showSnack();
                                }
                            } else {
                                this.Msg='no existe moneda de cambio en la lista'
                                this.color='red';
                                this.msgbox=true;
                                this.showSnack();
                            }
                        } else {
                            this.Msg='no existe moneda de cambio en la lista'
                            this.color='red';
                            this.msgbox=true;
                            this.showSnack();
                        }  
                    } else {
                        this.Msg='seleccione una bodega para agregar stock'
                        this.color='red';
                        this.msgbox=true;
                        this.showSnack();
                    }
                } else {
                    this.Msg='Ingrese forma de pago'
                    this.color='red';
                    this.msgbox=true;
                    this.showSnack();
                }
            } else {
                this.Msg='Debe ingresar numero de compra'
                this.color='red';
                this.msgbox=true;
                this.showSnack();
            }
            this.loading=false;
        },
        async update_importa(){
            let result = 0;
            try {
                //ingreasmos la integracion
                let total_save = 0;
                for (let index = 0; index < this.detalle_items.length; index++) {
                    const element = this.detalle_items[index];
                    const id_importa = element.id; 
                    const params={
                        'contrato': this.contrato,
                        'moneda': element.moneda,
                        'fecha_cambio': this.date1,
                        'valor_cambio': element.paridad,
                        'total_clp': element.total,
                        'valor_clp': element.clp,
                        'costo_clp': element.costo,
                        'fecha_integra': this.fecha,
                        'usuario': this.usu,
                        'bodega': this.bodega,
                        'estado':'I',
                    };
                    const response = await axios.put(process.env.VUE_APP_URL + '/api/inv/importa/'+ id_importa ,params);
                    const datos=response.data;
                    if (datos=='si'){
                        //mover stock
                        var parametros1={
                            'contrato': this.contrato,
                            'sku': element.sku,
                            'cantidad': element.cantidad,
                            'signo': '0+',
                            'bodega': this.bodega,
                            'usuario': this.usu,
                            'observa': 'Importa',
                            'origen':'Ingreso'};
                        const response1 = await axios.post(process.env.VUE_APP_URL + '/api/inv/stock',parametros1);
                        const datos1=response1.data;
                        if (datos1=='si'){ 
                            total_save = parseInt(total_save) + 1;
                        }                                
                    }
                };
                if(parseFloat(total_save)!=0){
                    result = parseFloat(total_save);
                }
            } catch (error) {
                console.log(error)
            };
            return result
        },
        open_compra(){
            if(this.rut!=''){
                if(this.detalle_items.length!=0){
                    this.d_compra=true;
                } else {
                    this.Msg='No existe detalle para integrar'
                    this.color='red';
                    this.msgbox=true;
                    this.showSnack();
                }
            } else {
                this.Msg='Seleccione solicitud'
                this.color='red';
                this.msgbox=true;
                this.showSnack();
            }
        }

    }

}
</script>